export enum CourseStatus {
  NOT_STARTED = "NOT_STARTED",
  IN_PROGRESS = "INPROGRESS",
  COMPLETED = "COMPLETED",
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
}

export enum CompletionStatus {
  ALL = "ALL",
  NEW_COURSES = "PENDING",
  STARTED = "IN_PROGRESS",
}

export interface CourseFilters {
  categoryIds: number[];
  searchText: string;
  status: boolean | null; // null = all, true = active, false = inactive
  completionStatus: CompletionStatus;
}

export interface CompletionStatusLabel {
  value: CompletionStatus;
  label: React.ReactNode;
}

export const completionStatusLabels: CompletionStatusLabel[] = [
  {
    value: CompletionStatus.ALL,
    label: "EDUCATION_PAGE.ALL_COURSES",
  },
  {
    value: CompletionStatus.NEW_COURSES,
    label: "EDUCATION_PAGE.STARTED",
  },
  {
    value: CompletionStatus.STARTED,
    label: "EDUCATION_PAGE.NEW_COURSES",
  },
];
